// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Nt-z","tooltipWrapper":"Ot-z","icon":"Pt-z","tooltip":"Qt-z","content":"Rt-z"};